import isB2CUser from './is-b2c-user';
import isUserAuthorized from './is-user-authorized';

export default {
  isB2CUser,
  isUserAuthorized,
};
